var path = 'api/Portal/Payment/'

const PaymentFee = 0.024

const MinimumFee = 1.00

function getHmacInfo (http) {
    return http.post(path + 'GetHmacInfo')
}

function getPayment (http, paymentId) {
    return http.get(path + 'GetPayment?paymentId=' + paymentId)
}

function getPaymentByCert (http, certId, modType) {
    return http.get(path + 'GetPaymentByCert?certId=' + certId + '&modType=' + modType)
}

// function insertPayment (http, paymentDto) {
//     return http.post(path + 'InsertPayment', paymentDto)
// }

function insertCertPayment (http, paymentDto) {
    return http.post(path + 'InsertCertPayment', paymentDto)
}

function handleTransaction (http, cardShieldTicket, paymentId) {
    return http.post(path + 'HandleTransaction', { cardShieldTicket: cardShieldTicket, paymentId: paymentId })
}

function getPaymentStatus (http, paymentId) {
    return http.post(path + 'GetPaymentStatus?paymentId=' + paymentId)
}

export default {
    getHmacInfo: getHmacInfo,
    getPayment: getPayment,
    // insertPayment: insertPayment,
    insertCertPayment: insertCertPayment,
    handleTransaction: handleTransaction,
    getPaymentStatus: getPaymentStatus,
    PaymentFee: PaymentFee,
    MinimumFee: MinimumFee,
    getPaymentByCert: getPaymentByCert
}
